export const TOGGLE_LINK_PAINEL = '[LINK PAINEL] TOGGLE LINK PAINEL';

export function toggleLinkPainel(_ASite)
{
    return {
        type: TOGGLE_LINK_PAINEL,
        site: _ASite
    }
}
